import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ResponseMsg from '../general/ResponseMsg';

const ExchangeOrder = ({ userData }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get order data from navigation state
  const order = location.state?.order;

  // Parse order_items JSON string to array
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [images, setImages] = useState([]);
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (order && order.order_items) {
      try {
        const parsedItems = JSON.parse(order.order_items);
        setItems(parsedItems);
      } catch (e) {
        console.error('Error parsing order items:', e);
      }
    }
  }, [order]);

  if (!order) {
    return <p>No order data received.</p>;
  }

  // Toggle checkbox selection for an item (by medicine_id)
  const toggleItem = (medicine_id) => {
    setSelectedItems(prev => ({
      ...prev,
      [medicine_id]: !prev[medicine_id],
    }));
  };

  // Handle image file input change (multiple files)
  const handleImageChange = (e) => {
    setImages(Array.from(e.target.files));
  };

  // Submit exchange request
  const handleSubmit = async (e) => {
    e.preventDefault();

const selectedExItems = items
  .filter(item => selectedItems[item.product_name])
  .map(item => ({
    name: item.product_name,
    qty: item.quantity,
    price: parseFloat(item.product_price),
    total_price: item.quantity * parseFloat(item.product_price)
  }));


    if (selectedExItems.length === 0) {
      setResponse('Please select at least one item to exchange.');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
      return;
    }

    setLoading(true);

    // Prepare form data for multipart upload (files + data)
    const formData = new FormData();
    formData.append('order_id', order.id);
    formData.append('user_id', userData.id);
    formData.append('req_type', 'Exchange');
    formData.append('req_status', 'Pending');

formData.append('ex_items', JSON.stringify(selectedExItems));

    images.forEach((file, idx) => {
      formData.append('attachments', file);
    });

    try {
      const res = await fetch(`https://api.kcmstore.in/store/ex-request/${userData.id}`, {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (res.ok) {
        setResponse('Exchange request submitted successfully!');
        setSelectedItems({});
        setImages([]);  
        navigate('/order-history')
      } else {
        setResponse(result.message || 'Failed to submit exchange request.');
      }
    } catch (err) {
      setResponse('An error occurred while submitting the request.');
    } finally {
      setLoading(false);
      setTimeout(() => setResponse(''), 2000);
    }
  };

  return (
    <>
      <section className='my-5'>
        <div className='container'>
          <div className='d-flex fs-5'>
            <span className='cursor-pointer me-3' onClick={() => navigate('/order-history')}>
              <i className="fa-solid fa-angle-left"></i>
            </span>
            <p className='fw-semibold'>
              Request Exchange for Order Id #{order.id}
            </p>
          </div>

            {/* {responseMessage && (
              <div className="alert alert-info">{responseMessage}</div>
            )} */}

          <form onSubmit={handleSubmit} className="mt-4">
            <h6>Select Items to Exchange:</h6>
            {items.length === 0 ? (
              <p>No items found in this order.</p>
            ) : (
              <div className="mb-3">
                {items.map(item => {
                  // Each item may have multiple images separated by commas
                  const imageUrls = item.image ? item.image.split(',') : [];
                  return (
                    <div className="d-flex mb-2">
                      <input
                        type="checkbox"
                        id={`item-${item.product_name}`}
                        checked={!!selectedItems[item.product_name]}
                        onChange={() => toggleItem(item.product_name)}
                      />
                      {/* <label htmlFor={`item-${item.medicine_id}`} className="ms-2 d-flex"> */}
                        <div className='ms-2'>
                          <div><strong>{item.product_name}</strong></div>
                          <div>Qty: {item.quantity} | Price: ₹{item.product_price} | Total: ₹{item.quantity * item.product_price}</div>
                        </div>
                    
                    </div>
                  );
                })}
              </div>
            )}

            <div className="mb-3">
              <label htmlFor="exchange-images" className="form-label fw-semibold">
                Upload Images (Proof for Exchange) - You can select multiple images
              </label>
              <input
                type="file"
                id="exchange-images"
                multiple
                accept="image/*"
                onChange={handleImageChange}
                className="form-control"
              />
              {images.length > 0 && (
                <small>{images.length} image(s) selected</small>
              )}
            </div>


            <button type="submit" className="sort-btn" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit Exchange Request'}
            </button>
          </form>
        </div>
      </section>

            {response && <ResponseMsg message={response} />}
    </>
  );
};

export default ExchangeOrder;
